// import ReviewList from "./ReviewList";
import ClassList from './ClassList';
import ProductIcon  from '@material-ui/icons/Collections';
import ClassShow from './ClassShow/index';

const resource = {
    icon: ProductIcon,
    list: ClassList,
    show: ClassShow,
};
export default resource;
